var map = {
	"./airasia.png": "4705",
	"./aplog.png": "9e8c",
	"./asiacargoairlines.png": "8ba1",
	"./batikair.png": "4dbb",
	"./cardig.png": "5db34",
	"./citilink.png": "eb4d",
	"./deraya.png": "bbd8",
	"./garudaair.png": "95bb",
	"./lionair.png": "95fe",
	"./myindo.png": "4434",
	"./noncommercialflight.png": "72ea",
	"./rimbun.jpg": "6568",
	"./trigana.png": "1dd3",
	"./trimglogo.png": "bbbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9dcd";